import axios from '@/http/index';

const base = '';
// 查询公告列表页展示功能
export const queryArticles = (id, params) => axios.get(`${base}/core/lookArticle/queryArticles?mainId=${id}`, params).then((res) => res.data);
// 查询员工查看公告详情功能
export const checkArticle = (params) => axios.get(`${base}/core/lookArticle/checkArticle`, params).then((res) => res.data);
